/**
 * sprint/constants.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Sprint-specific constants.
 */

// Re-use some constants from timeline if needed, but these are sprint-specific.
export const SPRINT_DURATIONS = [
    { value: 1, label: '1 Week' },
    { value: 2, label: '2 Weeks' },
    { value: 3, label: '3 Weeks' },
    { value: 4, label: '4 Weeks' }
];

export const SPRINT_START_DAYS = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];

export const DEFAULT_SPRINT_SETTINGS = {
    durationWeeks: 2,
    startDay: 'Monday',
    excludeCompanyHolidays: true,
    excludePublicHolidays: true,
    excludeEvents: false,
    autoCarryForward: true,
    autoGenerateReports: true,
    enableWorkloadSuggestions: true,
    enableDeadlinePrediction: true,
    enableBlockerDetection: true,
};
